<script>
    import { createEventDispatcher } from 'svelte';
    import Fa from 'svelte-fa'
    import { faRemove } from '@fortawesome/free-solid-svg-icons'
    import { delCustomer } from '../customerStore'
    import ModalYesNo from '../components/ModalYesNo.svelte';
    
    export let customer;
    let modal;

    const dispatch = createEventDispatcher();
    function clickExecuted() {
        modal.show();
    }

    function doDelete() {
        delCustomer(customer).then(() => {
            dispatch('clicked', {
                
            });
        });
    }
</script>

<div class="IconDel" on:click={clickExecuted}>
    <Fa icon={faRemove} />
</div>
<ModalYesNo title='Löschen' text='Wollen Sie diesen Kunden wirklich löschen?' bind:this={modal} on:accepted={doDelete}/>

<style>
    .IconDel {
        cursor: pointer;
        color: red;
    }
</style>